<template>
  <img class="img-line" src="../../public/img/apracam_img/divisonBot.png" />
</template>
<style scoped>
.img-line {
  width: 100%;
  height: 20px;
}
</style>